import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ReplenishmentRead } from '../../entities/replenishment.dto';

@Injectable()
export class ReplenishmentStore extends AbstractEntityStore<ReplenishmentRead> {
    constructor() {
        super(PFWmsEntities.Replenishment);
    }
}
